import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="global-loading-overlay" [class.show]="isVisible()">
      <div class="glowing-aura"></div>
      <div class="loader-content">
        <div class="progress-indicator">
          <div class="spinner-ring"></div>
        </div>
        <p class="loading-text">{{ message() }}</p>
      </div>
    </div>
  `,
  styles: [
    `
      .global-loading-overlay {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: rgba(10, 15, 25, 0.85);
        backdrop-filter: blur(8px);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.4s ease;

        &.show {
          opacity: 1;
          pointer-events: all;
        }
      }

      .glowing-aura {
        position: absolute;
        width: 300px;
        height: 300px;
        background: radial-gradient(
          circle,
          rgba(197, 164, 126, 0.15) 0%,
          rgba(197, 164, 126, 0) 70%
        );
        border-radius: 50%;
        animation: pulse 3s ease-in-out infinite;
      }

      .loader-content {
        position: relative;
        z-index: 10;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
      }

      .progress-indicator {
        position: relative;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .spinner-ring {
        position: absolute;
        inset: 0;
        border: 3px solid rgba(255, 255, 255, 0.1);
        border-top-color: var(--admin-accent, #c5a47e);
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      .loading-text {
        color: #ffffff;
        font-size: 1.1rem;
        font-weight: 500;
        letter-spacing: 0.03em;
        margin: 0;
        animation: fade 2s ease-in-out infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }

      @keyframes pulse {
        0% {
          transform: scale(0.8);
          opacity: 0.5;
        }
        50% {
          transform: scale(1.2);
          opacity: 1;
        }
        100% {
          transform: scale(0.8);
          opacity: 0.5;
        }
      }

      @keyframes fade {
        0%,
        100% {
          opacity: 0.7;
        }
        50% {
          opacity: 1;
        }
      }
    `,
  ],
})
export class LoadingOverlayComponent {
  isVisible = signal(false);
  message = signal('Saving your progress...');

  show(msg: string = 'Saving your progress...') {
    this.message.set(msg);
    this.isVisible.set(true);
  }

  hide() {
    this.isVisible.set(false);
  }
}
